import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[appParallax]",
})
export class ParallaxDirective {
  @Input() parallaxSpeed = 0.3;

  constructor(private el: ElementRef) {}

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const scrolled = window.pageYOffset;
    this.el.nativeElement.style.transform = `translateY(${
      scrolled * this.parallaxSpeed
    }px)`;
  }
}
